import React, { useEffect, useState } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Pagination,
  Tabs,
  Tab,
  TextField,
} from '@mui/material';
import ReusableTable from '../../component/ui/ReusableTable';
import { saveAs } from 'file-saver';
import { useNavigate } from 'react-router-dom';
import '../../styles/Booking.scss';
import '../../styles/UserStyles.css';
import SearchAndButtonTab from '../../component/ui/SearchAndButtonTab';
import { formatDateWithAmPm, getStatusClass } from '../../Style';
import {
  BOOKING_AIRPORT_DETAILS,
  EDIT_BOOKINGS,
  VIEW_BOOKINGS,
} from '../../component/common/Routes/AppRoutes';
import { useDispatch, useSelector } from 'react-redux';
import {
  VENDOR_BOOKING_AIRPORT_DETAILS,
  VENDOR_VIEW_BOOKINGS,
} from '../../component/common/Routes/VendorRoutes';
import {
  CUSTOMER_BOOKING_AIRPORT_DETAILS,
  CUSTOMER_VIEW_BOOKINGS,
} from '../../component/common/Routes/CustomerRoutes';
import {
  fetchBookingsRequest,
  deleteBookingRequest,
  fetchCustomerBookingsRequest,
  resetBookingDetails,
  fetchComplementaryBookingsRequest,
  fetchInstantBookingsRequest,
  getAllBookingsRequest,
} from '../../redux/Bookings/BookingAction';
import CustomButton from '../../component/ui/FormFields/Button';
import { toast, ToastContainer } from 'react-toastify';
import Loading from '../../component/ui/Loading';

const BookingList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const bookings = useSelector((state) => state.booking.bookings || []);

  const bookingsForExport = useSelector(
    (state) => state.booking.bookingsForExport || []
  );

  console.log("bookings", bookings)
  console.log("bookingsForExport", bookingsForExport)
  const totalRecord = useSelector((state) => state.booking?.totalRecords || []);
  const deleteSuccess = useSelector((state) => state.booking?.message);
  const { loading: viewListLoading, deleteLoading } = useSelector(
    (state) => state.booking
  );

  const { user } = useSelector((state) => state.auth);
  const permissions = user?.permissions;
  const [type, setType] = useState(2);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchColumn, setSearchColumn] = useState('booking_number');
  const [open, setOpen] = useState(false);
  const [bookingToDelete, setBookingToDelete] = useState(null);
  const [page, setPage] = useState(1);
  const [complementaryStatus, setComplementaryStatus] = useState(2);
  const [instantStatus, setInstantStatus] = useState(2);
  const currentDate = new Date().toISOString().split('T')[0];
  const [cancelReason, setCancelReason] = useState('');
  const [booked_type, setBooked_type] = useState(1);
  const [triggerExport, setTriggerExport] = useState(false);
  const [allBookings, setAllBookings] = useState([]);
  const [filteredBookings, setFilteredBookings] = useState([]);
  const rowsPerPage = 5;
  let bookingType = 'upcoming';
  if (type === 1) {
    bookingType = 'previous';
  } else if (type === 3) {
    bookingType = 'cancelled';
  } else if (type === 2) {
    bookingType = 'upcoming';
  }

  useEffect(() => {
    let newBookedType;
    if (type === 1 || type === 2 || type === 3) {
      newBookedType = 1;
    } else if (type === 4) {
      newBookedType = 2;
    } else if (type === 5) {
      newBookedType = 3;
    }
    setBooked_type(newBookedType);
  }, [type]);

  useEffect(() => {
    return () => {
      dispatch(resetBookingDetails());
    }
  }, [])

  useEffect(() => {
    if (triggerExport && user.role === "Admin") {
      dispatch(
        getAllBookingsRequest({
          booked_type: booked_type,
        })
      );
      setTriggerExport(false);
    }
  }, [dispatch, booked_type, triggerExport, type, user.role]);

  useEffect(() => {
    if ((triggerExport && user.role === 'Vendor') || user.role === 'Customer') {
      if (
        user.role === 'Vendor' ||
        (user.role === 'Customer' && triggerExport)
      ) {
        dispatch(
          fetchCustomerBookingsRequest({
            customer_id: user.customer_id || '',
            pageNo: page,
            pageSize: rowsPerPage,
            currentDate,
            vendor_id: user.vendor_id || '',
          })
        );
      }
      setTriggerExport(false);
    }
  }, [dispatch, booked_type, triggerExport]);


  useEffect(() => {
    const fetchAllData = async () => {
      if (user.role === 'Customer' || user.role === 'Vendor') {
        dispatch(
          fetchCustomerBookingsRequest({
            customer_id: user.customer_id || '',
            pageNo: 1,
            pageSize: 1000000,
            type: bookingType,
            booked_type: 1,
            currentDate,
            vendor_id: user.vendor_id || '',
          })
        );
      } else {
        if (type === 4) {
          dispatch(
            fetchComplementaryBookingsRequest({
              pageNo: 1,
              pagesize: 1000000,
              approove_status: complementaryStatus,
              currentDate,
            })
          );
        } else if (type === 5) {
          let instantBookingType;
          switch (instantStatus) {
            case 1:
              instantBookingType = 'previous';
              break;
            case 2:
              instantBookingType = 'upcoming';
              break;
            case 3:
              instantBookingType = 'cancelled';
              break;
            default:
              instantBookingType = 'upcoming';
          }

          dispatch(
            fetchInstantBookingsRequest({
              pageNo: 1,
              pagesize: 1000000,
              type: instantBookingType,
              currentDate,
            })
          );
        } else {
          dispatch(
            fetchBookingsRequest({
              pageNo: 1,
              pagesize: 1000000,
              type: bookingType,
              booked_type: 1,
              currentDate,
            })
          );
        }
      }
    };

    fetchAllData();
  }, [dispatch, user.role, type, complementaryStatus, instantStatus]);

  // Process data and apply filter whenever bookings or search changes
  useEffect(() => {
    const processedData = preprocessData(bookings);
    setAllBookings(processedData);

    // Apply filtering
    const filtered = processedData.filter((booking) => {
      let columnValue = booking[searchColumn];

      if (columnValue) {
        if (typeof columnValue === 'string') {
          columnValue = columnValue.toLowerCase();
        } else if (columnValue instanceof Date) {
          columnValue = formatDateWithAmPm(columnValue);
        } else {
          columnValue = String(columnValue);
        }
      } else {
        columnValue = '';
      }

      return columnValue.includes(searchQuery.toLowerCase());
    });

    setFilteredBookings(filtered);
    // Reset to first page when filtering changes
    setPage(1);
  }, [bookings, searchQuery, searchColumn]);

  const handleView = (booking) => {
    const bookingId = booking?.booking_number;

    if (permissions?.bookings?.view && user?.role === 'Staff') {
      navigate(`${VIEW_BOOKINGS.replace(':bookingId', bookingId)}`);
    } else if (user?.role === 'Vendor') {
      navigate(`${VENDOR_VIEW_BOOKINGS.replace(':bookingId', bookingId)}`);
    } else if (user?.role === 'Customer') {
      navigate(`${CUSTOMER_VIEW_BOOKINGS.replace(':bookingId', bookingId)}`);
    } else if (user?.role === 'Admin') {
      navigate(`${VIEW_BOOKINGS.replace(':bookingId', bookingId)}`);
    }
  };

  const handleEdit = (booking) => {
    const bookingId = booking?.booking_number;
    if (permissions?.bookings?.edit && user?.role === 'Staff') {
      navigate(`${EDIT_BOOKINGS.replace(':bookingId', bookingId)}`);
    }
    if (user?.role === 'Admin') {
      navigate(`${EDIT_BOOKINGS.replace(':bookingId', bookingId)}`, {
        state: { bookingData: booking },
      });
    }
  };

  const handleOpenPopup = (booking) => {
    setBookingToDelete(booking);
    setOpen(true);
  };

  const handleClosePopup = () => {
    setBookingToDelete(null);
    setOpen(false);
  };

  useEffect(() => {
    if (deleteSuccess === 'Your bookingservice cancelled') {
      toast.success('Your bookingservice cancelled', {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          dispatch(resetBookingDetails());
        },
      });
    }
  }, [deleteSuccess]);

  const handleConfirmDelete = () => {
    if (bookingToDelete) {
      const bookingId = bookingToDelete.booking_number;

      dispatch(deleteBookingRequest({ bookingId, cancel_notes: cancelReason }));

      if (user.role === 'Customer') {
        dispatch(
          fetchCustomerBookingsRequest({
            customerId: user.customer_id,
            pageNo: 1,
            pageSize: 1000,
            type: bookingType,
          })
        );
      } else {
        dispatch(
          fetchBookingsRequest({
            pageNo: 1,
            pagesize: 1000,
            type: bookingType,
            booked_type: 1,
          })
        );
      }
    }
    handleClosePopup();
  };

  const handleTabChange = (event, newType) => {
    setType(newType);
    setPage(1);
    if (newType !== 4 || newType !== 5) {
      setComplementaryStatus(2);
      setInstantStatus(2);
    }
    // dispatch(resetBookingDetails());
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleExport = () => {
    setTriggerExport(true);
    setTimeout(() => {
      const csvHeaders = [
        'Booking Number,Booking Serial No,Booking Date,Booked User Name,Booked For,Airport Name,Airport Type,First Name,Last Name,Company Name,No Of Adult,No Of Child,No Of Infant,Total Passenger,Service,Service Type,Notes,Arrival Date/Time,Arrival City,Arrival Airline,Arrival Flight Number,Departure Date/Time,Departure City,Departure Airline,Departure Flight Number,PNR Number,Payment Status,Approval Status,Booked Type',
      ];

      let processedDataForExport;

      if (user?.role === "Admin" || user?.role === "Staff") {
        processedDataForExport = preprocessData(bookingsForExport)
      } else if (user?.role === "Vendor" || user?.role === "Customer") {
        processedDataForExport = preprocessData(bookings)
      }

      const csvRows = processedDataForExport.map((booking) => {
        const escapeCsvField = (field) => {
          if (field === null || field === undefined) return '""';
          const stringField = String(field || '-');
          if (
            stringField.includes(',') ||
            stringField.includes('"') ||
            stringField.includes('\n')
          ) {
            return `"${stringField.replace(/"/g, '""')}"`;
          }
          return stringField;
        };

        const getApprovalStatusText = (statusCode) => {
          if (statusCode === 1 || statusCode === '1') return 'Approved';
          if (statusCode === 2 || statusCode === '2') return 'Pending';
          if (statusCode === 3 || statusCode === '3') return 'Rejected';
          return statusCode || '';
        };

        const getBookedTypeLabel = (typeCode) => {
          switch (typeCode) {
            case 1:
              return 'Regular';
            case 2:
              return 'Regular';
            case 3:
              return 'Regular';
            case 4:
              return 'Complementary';
            case 5:
              return 'Instant Booking';
            default:
              return typeCode || '';
          }
        };

        const approvalStatus = booking.approove_status || booking.approove_status;
        const approvalStatusText = getApprovalStatusText(approvalStatus);

        return [
          escapeCsvField(booking.booking_number),
          escapeCsvField(booking.booking_serial_no),
          escapeCsvField(booking.date_of_booking),
          escapeCsvField(booking.booked_user_name),
          escapeCsvField(booking.booked_for),
          escapeCsvField(booking.airport_name),
          escapeCsvField(booking.airport_type),
          escapeCsvField(booking.first_name),
          escapeCsvField(booking.last_name),
          escapeCsvField(booking.company_name),
          escapeCsvField(booking.number_of_adults),
          escapeCsvField(booking.number_of_child),
          escapeCsvField(booking.number_of_infant),
          escapeCsvField(booking.total_passenger),
          escapeCsvField(booking.service),
          escapeCsvField(booking.service_type_label),
          escapeCsvField(booking.notes),
          escapeCsvField(booking.datetime_of_arrival),
          escapeCsvField(booking.arrival_city),
          escapeCsvField(booking.arrival_airline),
          escapeCsvField(booking.arrival_flight_number),
          escapeCsvField(booking.datetime_of_departure),
          escapeCsvField(booking.departure_city),
          escapeCsvField(booking.departure_airline),
          escapeCsvField(booking.departure_flight_number),
          escapeCsvField(booking.pnr_number),
          escapeCsvField(booking.payment_status),
          escapeCsvField(approvalStatusText),
          escapeCsvField(getBookedTypeLabel(type))
        ].join(',');
      });

      const csvContent = [csvHeaders, ...csvRows].join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      saveAs(blob, 'bookings.csv');
    }, 1500);
  };


  const preprocessData = (data) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [];
    }

    return data.map((item) => {
      const bookingDetail = item.BookingDetail || {};
      const billingAddress = item.BillingAddress || {};
      const order = item.Order || {};
      const numberOfAdults = bookingDetail.number_of_adults || 0;
      const numberOfChildren = bookingDetail.number_of_child || 0;
      const numberOfInfants = bookingDetail.number_of_infant || 0;
      const totalPassengers =
        numberOfAdults + numberOfChildren + numberOfInfants;
      const bookedUser = bookingDetail['BookedUser'] || {};
      let bookedUserName = '-';
      if (bookedUser?.user_type === 3 && bookedUser?.Customer) {
        bookedUserName = bookedUser?.Customer?.full_name;
      } else if (bookedUser?.user_type === 2 && bookedUser?.Vendor) {
        bookedUserName = bookedUser?.Vendor?.full_name;
      } else if (bookedUser?.user_type === 4 && bookedUser?.Staff) {
        bookedUserName = bookedUser?.Staff?.full_name;
      } else {
        bookedUserName = `${bookedUser?.first_name}  ${bookedUser?.last_name}`;
      }

      return {
        booking_number: item.id || '-',
        booking_serial_no: item.booking_serial_no || '',
        date_of_booking: item.created_at
          ? formatDateWithAmPm(item.created_at)
          : '-',
        booked_user_name: bookedUserName,
        booked_for: item?.Customer?.full_name,
        pnr_number: item?.pnr_number,
        airport_name: item?.Airport?.name || '-',
        airport_type: item?.Airport?.airport_type || '-',
        first_name: billingAddress.first_name || '-',
        last_name: billingAddress.last_name || '-',
        company_name: billingAddress.company_name || '-',
        number_of_adults: numberOfAdults || '-',
        number_of_child: numberOfChildren || '-',
        number_of_infant: numberOfInfants || '-',
        total_passenger: totalPassengers,
        service: item.Service?.services || order.service || '-',
        service_type_label:
          { 1: 'Arrival', 2: 'Departure', 3: 'Transit' }[item.service_type] ||
          '-',
        notes: bookingDetail.notes || '-',
        datetime_of_arrival:
          bookingDetail?.date_of_arrival != '2000-01-01'
            ? ` ${bookingDetail?.date_of_arrival} ${bookingDetail?.time_of_arrival} `
            : '-',
        datetime_of_departure:
          bookingDetail?.date_of_departure != '2000-01-01'
            ? ` ${bookingDetail?.date_of_departure} ${bookingDetail?.time_of_departure} `
            : '-',
        arrival_city: bookingDetail.arrival_city || '-',
        arrival_airline: bookingDetail.arrival_airlines || '-',
        arrival_flight_number: bookingDetail.arrival_flight_number || '-',
        departure_city: bookingDetail.departure_city || '-',
        departure_airline: bookingDetail.departure_airlines || '-',
        departure_flight_number: bookingDetail.departure_flight_number || '-',
        payment_status: order.status || '-',
        approove_status: item.approove_status,
        booked_type: item.booked_type
      };
    });
  }
  if (viewListLoading) {
    return <Loading text='Loading Booking Details...' />;
  }

  // Get paginated data
  const paginatedData = filteredBookings.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const headers = [
    { field: 'booking_serial_no', header: 'Booking Number' },
    {
      field: 'date_of_booking',
      header: 'Booking Date',
      render: (value) => (value ? formatDateWithAmPm(value) : '-'),
    },
    { field: 'booked_user_name', header: 'Booked By' },
    { field: 'booked_for', header: 'Booked For' },
    { field: 'number_of_adults', header: 'No of Adults' },
    { field: 'number_of_child', header: 'No of Children' },
    { field: 'number_of_infant', header: 'No of Infants' },
    { field: 'total_passenger', header: 'Total Passengers' },
    { field: 'service', header: 'Service' },
    { field: 'service_type_label', header: 'Service Type' },
    {
      field: 'datetime_of_arrival',
      header: 'Arrival Date/Time',
      render: (value) => (value ? formatDateWithAmPm(value) : '-'),
    },
    { field: 'arrival_city', header: 'Arrival City' },
    { field: 'arrival_airline', header: 'Arrival Airline' },
    { field: 'arrival_flight_number', header: 'Arrival Flight Number' },
    {
      field: 'datetime_of_departure',
      header: 'Departure Date/Time',
      render: (value) => (value ? formatDateWithAmPm(value) : '-'),
    },
    { field: 'departure_city', header: 'Departure City' },
    { field: 'departure_airline', header: 'Departure Airline' },
    { field: 'departure_flight_number', header: 'Departure Flight Number' },
    { field: 'pnr_number', header: 'PNR Number' },
    {
      field: 'payment_status',
      header: 'Payment Status',
      render: (value) => (
        <span className={`badge ${getStatusClass(value)}`}>{value}</span>
      ),
    },
    { field: 'notes', header: 'Notes' },
  ];

  const bookingFilterHeaders = [
    { value: 'booking_serial_no', label: 'Booking Number' },
    { value: 'date_of_booking', label: 'Booking Date' },
    { value: 'booked_user_name', label: 'Booked By' },
    { value: 'booked_for', label: 'Booked For' },
    { value: 'number_of_adults', label: 'No of Adults' },
    { value: 'number_of_child', label: 'No of Children' },
    { value: 'number_of_infant', label: 'No of Infants' },
    { value: 'total_passenger', label: 'Total Passengers' },
    { value: 'service', label: 'Service' },
    { value: 'service_type_label', label: 'Service Type' },
    { value: 'datetime_of_arrival', label: 'Arrival Date/Time' },
    { value: 'arrival_city', label: 'Arrival City' },
    { value: 'arrival_airline', label: 'Arrival Airline' },
    { value: 'arrival_flight_number', label: 'Arrival Flight Number' },
    { value: 'datetime_of_departure', label: 'Departure Date/Time' },
    { value: 'departure_city', label: 'Departure City' },
    { value: 'departure_airline', label: 'Departure Airline' },
    { value: 'departure_flight_number', label: 'Departure Flight Number' },
    { value: 'pnr_number', label: 'PNR Number' },
    { value: 'payment_status', label: 'Payment Status' },
    { value: 'notes', label: 'Notes' },
  ];

  const renderCustomDeleteButton = (item) =>
    (permissions?.bookings?.delete || user?.user_type === 1) &&
    user?.role !== 'Customer' &&
    user?.role !== 'Vendor' &&
    type !== 3 && (
      <Button
        variant='outlined'
        size='small'
        onClick={() => handleOpenPopup(item)}
        className='grey-button'
      >
        CANCEL
      </Button>
    );

  const renderCustomEditButton = (item) =>
    (permissions?.bookings?.delete || user?.user_type === 1) &&
    user?.role !== 'Customer' &&
    user?.role !== 'Vendor' &&
    type !== 3 && (
      <Button
        variant='outlined'
        size='small'
        onClick={() => handleEdit(item)}
        className='orange-button'
      >
        EDIT
      </Button>
    );

  const getTotalPages = () => {
    return Math.max(1, Math.ceil(filteredBookings.length / rowsPerPage));
  };

  return (
    <>
      <ToastContainer />
      <Box className='container'>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <SearchAndButtonTab
                  title='Bookings'
                  columns={bookingFilterHeaders}
                  searchColumn={searchColumn}
                  setSearchColumn={setSearchColumn}
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  handleExport={handleExport}
                  routeName={
                    user.role === 'Vendor'
                      ? VENDOR_BOOKING_AIRPORT_DETAILS
                      : user.role === 'Customer'
                        ? CUSTOMER_BOOKING_AIRPORT_DETAILS
                        : BOOKING_AIRPORT_DETAILS
                  }
                  permissions={permissions}
                  user={user}
                />

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Tabs
                    value={type}
                    onChange={handleTabChange}
                    indicatorColor='primary'
                    textColor='primary'
                  >
                    <Tab label='Upcoming' value={2} />
                    <Tab label='Completed' value={1} />
                    {user.role !== 'Customer' && (
                      <Tab label='Cancelled' value={3} />
                    )}
                    {user.role !== 'Customer' && user.role !== 'Vendor' && (
                      <Tab label='Complementary' value={4} />
                    )}
                    {user.role !== 'Customer' && user.role !== 'Vendor' && (
                      <Tab label='Instant Booking' value={5} />
                    )}
                  </Tabs>
                </Box>

                {type === 4 && (
                  <Tabs
                    value={complementaryStatus}
                    onChange={(event, newStatus) =>
                      setComplementaryStatus(newStatus)
                    }
                    indicatorColor='primary'
                    textColor='primary'
                    sx={{
                      ml: 2,
                      '& .MuiTabs-indicator': {
                        backgroundColor: 'primary.main',
                      },
                    }}
                  >
                    <Tab label='Pending' value={2} className='tab-heights' />
                    <Tab label='Approved' value={1} className='tab-heights' />
                    <Tab label='Rejected' value={3} className='tab-heights' />
                  </Tabs>
                )}

                {type === 5 && (
                  <Tabs
                    value={instantStatus}
                    onChange={(event, newStatus) => setInstantStatus(newStatus)}
                    indicatorColor='primary'
                    textColor='primary'
                    sx={{
                      ml: 2,
                      '& .MuiTabs-indicator': {
                        backgroundColor: 'primary.main',
                      },
                    }}
                  >
                    <Tab label='Upcoming' value={2} className='tab-heights' />
                    <Tab label='Completed' value={1} className='tab-heights' />
                    <Tab label='Cancelled' value={3} className='tab-heights' />
                  </Tabs>
                )}

                <ReusableTable
                  data={paginatedData.length > 0 ? paginatedData : []}
                  title='Bookings'
                  headers={headers}
                  paginatedData={paginatedData}
                  handleOpenPopup={handleOpenPopup}
                  renderEditButton={renderCustomEditButton}
                  renderDeleteButton={renderCustomDeleteButton}
                  handleView={handleView}
                  noRecordsText='No records found'
                />
                <Box mt={2} display='flex' justifyContent='end'>
                  {filteredBookings.length > 0 && (
                    <Pagination
                      count={getTotalPages()}
                      page={Math.min(page, getTotalPages())}
                      onChange={handlePageChange}
                      color='primary'
                    />
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Dialog open={open} onClose={handleClosePopup} maxWidth='sm' fullWidth>
          <DialogTitle sx={{ fontWeight: 'bold', textAlign: 'center' }}>
            Confirm Cancellation
          </DialogTitle>

          <DialogContent sx={{ p: 3 }}>
            <DialogContentText
              sx={{ mb: 2, textAlign: 'center', fontSize: '16px' }}
            >
              Are you sure you want to cancel this booking? <br />
              <strong>Booking ID: {bookingToDelete?.booking_serial_no}</strong>
            </DialogContentText>

            <TextField
              autoFocus
              margin='dense'
              label='Reason for Cancellation'
              type='text'
              name='cancelReason'
              fullWidth
              multiline
              rows={4}
              variant='outlined'
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              required
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                },
              }}
            />
          </DialogContent>

          <DialogActions sx={{ justifyContent: 'end', px: 3, pb: 3 }}>
            <Button
              size='medium'
              onClick={handleClosePopup}
              className='handle-back'
              variant='outlined'
              sx={{
                borderRadius: '8px',
                minWidth: '100px',
              }}
            >
              Cancel
            </Button>

            <CustomButton
              variant='contained'
              className='handle-delete'
              type='submit'
              size='medium'
              loading={deleteLoading}
              text='Confirm Cancel'
              onClick={handleConfirmDelete}
              disabled={!cancelReason.trim()}
              sx={{
                borderRadius: '8px',
                minWidth: '130px',
                backgroundColor: '#d32f2f',
                '&:hover': {
                  backgroundColor: '#b71c1c',
                },
              }}
            />
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};
export default BookingList;
